export enum CostType {
  PRODUCTION_COST = 'PRODUCTION_COST',
  WORK_CENTER_COST = 'WORK_CENTER_COST',
  PACKAGE_COST = 'PACKAGE_COST',
  UNBALANCED_PENALTY = 'UNBALANCED_PENALTY',
}

export enum Severity {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}

export const costToSeverity = (cost: number, type: CostType): Severity => {
  switch (type) {
    case CostType.PRODUCTION_COST:
      return severityRanges(cost, 10, 50)
    case CostType.WORK_CENTER_COST:
      return severityRanges(cost, 10, 50)
    case CostType.PACKAGE_COST:
      return severityRanges(cost, 1, 10)
    case CostType.UNBALANCED_PENALTY:
      return severityRanges(cost, 0.5, 2)
    default:
      return type satisfies never // make switch exhaustive
  }
}

const severityRanges = (cost: number, lower: number, upper: number): Severity => {
  if (cost < lower) {
    return Severity.LOW
  } else {
    return cost > upper ? Severity.HIGH : Severity.MEDIUM
  }
}
